<template>
  <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
    <div class="row">
      <div class="col-12">
        <TextEditor
            v-model="formData.description"
            @update:model-value="formData.description = $event"
            :inputStyle="{ height: '200px' }"
            label="Beschreibung"/>
      </div>
    </div>

    <div class="d-flex justify-content-center w-100 mt-3">
      <button class="btn btn-primary" type="submit">{{ $t('general.button.save') }}</button>
    </div>
  </form>
</template>

<script setup>
import coachBillingService from '@/api/CoachBilling';
import TextEditor from '@/components/TextEditor.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { defineEmits, defineProps, onMounted, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  coachBillId: {
    type: [Number, String],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  description: '',
});

const { coachBillId } = toRefs(props);

async function submitForm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    await coachBillingService.coordinatorRejectBill(formData.value, coachBillId.value);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  isLoaded.value = true;
});
</script>
<style scoped>

</style>